// Save the original console.log
const originalConsoleLog = console.log;

// Overload console.log
console.log = function (...args) {
    if(import.meta.env.DEV) {
        const timestamp = new Date().toISOString();
        originalConsoleLog(`[${timestamp}]`, ...args);
    }
};

// Export any custom functions or just an acknowledgment
export function enableCustomLogging() {
    if(import.meta.env.DEV) {
        console.log("console.log overloading enabled");
    }
}
